import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ROTUES } from "../../utils/global";
import EditIcon from "../../assets/Icons/EditIcon";
import DeleteIcon from "../../assets/Icons/DeleteIcon";
import { deleteRoomAction } from "../../store/actions/projectAction";

function Rooms() {
  const rooms = useSelector((state) => state.project?.rooms);

  const dispatch = useDispatch();

  const handleDelete = (id, projectId) => {
    dispatch(
      deleteRoomAction({
        id,
        projectId,
      })
    );
  };
  

  if (!rooms) {
    return <div>Sections Not Found</div>;
  }

  return (
    <table className="min-w-full bg-white">
      <thead>
        <tr>
          <th className="px-4 py-4 border-b text-left">Section Name</th>
          <th className="px-4 py-4 border-b text-left">Room Name</th>
          <th className="px-4 py-4 border-b text-left">Actions</th>
        </tr>
      </thead>
      <tbody>
        {rooms.map((room, index) => (
          <tr key={index} className="hover:bg-gray-100">
            <td className="px-4 py-4 border-b">{room?.section.name}</td>
            <td className="px-4 py-4 border-b">{room.name}</td>
            <td className="px-4 py-4 border-b flex space-x-2">
              <Link
                to={`${ROTUES.editTouch}/dsfasdf`}
                className="text-green-500 hover:text-green-700"
              >
                {/* <EditIcon /> */}
              </Link>
              <button
                className="text-red-500 hover:text-red-700"
                onClick={() => handleDelete(room?._id, room?.project?._id)}
              >
                <DeleteIcon />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default Rooms;
